import { reactive } from 'vue'

const state = reactive({
  instances: {}
})

let validatorRegistered = false

const registerValidator = () => {
  if (validatorRegistered) return

  const forms = window.epi && window.epi.EPiServer && window.epi.EPiServer.Forms
  if (!forms) return

  // eslint-disable-next-line no-undef
  jQuery.extend(true, forms, {
    Validators: {
      'Website.Features.Blocks.Components.InvisibleRecaptchaElementBlockComponent.InvisibleRecaptchaValidator': (fieldName) => {
        const instance = state.instances[fieldName]
        if (!instance) return { isValid: false }

        const isValid = !!instance.getToken()
        if (!isValid) {
          instance.verify()
        }
        return { isValid }
      }
    }
  })

  validatorRegistered = true
}

export default () => {
  const registerInstance = (fieldName, getToken, verify) => {
    state.instances[fieldName] = { getToken, verify }
    registerValidator()
  }

  const unregisterInstance = (fieldName) => {
    delete state.instances[fieldName]
  }

  return {
    registerInstance,
    unregisterInstance
  }
}
